"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.audioEvent = void 0;
var consts_1 = require("../consts");
var audioEvent = function (event, action) {
    var _a, _b, _c, _d;
    return {
        event: "audio",
        eventInfo: "audio",
        action: action,
        audio: __assign(__assign({}, event.eventData), { audioID: ((_a = event.eventData) === null || _a === void 0 ? void 0 : _a.audioID) || consts_1.NOT_AVAILABLE, audioMetaTags: ((_b = event.eventData) === null || _b === void 0 ? void 0 : _b.audioMetaTags) || consts_1.NOT_AVAILABLE, audioTime: ((_c = event.eventData) === null || _c === void 0 ? void 0 : _c.audioTime) || consts_1.NOT_AVAILABLE, audioTitle: ((_d = event.eventData) === null || _d === void 0 ? void 0 : _d.audioTitle) || consts_1.NOT_AVAILABLE }),
    };
};
exports.audioEvent = audioEvent;
